import React from 'react'
import { Link } from 'gatsby'
import { LINK } from '../styles/colors'

export const SUBJECTS = [
  'Aplicativo',
  'Carências do Plano',
  'Dúvidas Gerais',
  'Nossos Planos',
  'Rede Credenciada',
]

export const QUESTIONS = [
  {
    subject: 'Aplicativo',
    text: 'Como tenho acesso ao Aplicativo?',
    answer: 'Fácil! Acesse a Loja de Aplicativos do seu smartphone e busque por W.Dental e depois é só baixar. Ah! Lembre-se que no primeiro acesso é necessário criar uma senha. Se precisar de apoio, só avisar.'
  },
  {
    subject: 'Carências do Plano',
    text: 'Meu plano tem carência?',
    answer: 'Se optou pelo plano anual você ganha redução da carência e pode utilizar seu plano logo após a liberação, ótimo né? Já no plano mensal é necessário, aguardar um pouco para realizar alguns procedimentos. Consulte as condições gerais dos planos.'
  },
  {
    subject: 'Dúvidas Gerais',
    text: 'Qual forma de pagamento?',
    answer: 'Nos planos mensais, o pagamento é realizado através do boleto bancário ou cartão de crédito. Já nos planos anuais, além do boleto bancário, temos o cartão de crédito e PicPay. Aproveite!'
  },
  {
    subject: 'Dúvidas Gerais',
    text: 'Como consigo o status da minha compra?',
    answer: 'Após a finalização da compra, você receberá um e-mail de confirmação explicando os próximos passos! E se ainda surgir dúvidas, fale com a gente.',
  },
  {
    subject: 'Dúvidas Gerais',
    text: 'Quando inicia a vigência do meu contrato?',
    answer: 'A vigência se inicia após recebermos seu primeiro  pagamento, cartão ou boleto e a renovação ocorre de forma automática.'
  },
  {
    subject: 'Dúvidas Gerais',
    text: 'Quando terei acesso a carteirinha?',
    answer: 'Se optar pelo pagamento via cartão de crédito sua carteirinha ficará disponível no mesmo dia em nosso app ou site e você já pode marcar sua primeira consulta, legal né? Agora se você optou pelo pagamento via boleto, o prazo para liberação da sua carteirinha é de 1 (um) dia útil após pagamento da primeira mensalidade.'
  },
  {
    subject: 'Dúvidas Gerais',
    text: 'Onde consigo a segunda via do Boleto?',
    answer: [
      'No final da contratação ele fica disponível para você, mas encaminhamos para seu e-mail e o código por SMS. Caso não tenha recebido você pode tirar a segunda via ',
      <a href="https://minha.w.dental/login" rel="noopener noreferrer" target="_blank">
        clicando aqui
      </a>      
    ]
  },
  {
    subject: 'Nossos Planos',
    text: 'Onde posso utilizar meu plano?',
    answer: [
      'Com a W.Dental você tem mais de 17 mil opções de atendimento em todo Brasil! Consulte nossa rede credenciada, ', 
      <Link to="/rede-credenciada/" key="faq-link" style={{color: LINK}}>
        clicando aqui
      </Link>,
      '.'
    ]
  },
  {
    subject: 'Nossos Planos',
    text: 'Existe limite para o número de consultas ou tratamento?',
    answer: 'Não. Todos tratamentos que tiverem indicação do seu dentista e cobertura do seu plano, serão realizadas.'
  },
  {
    subject: 'Nossos Planos',
    text: 'Os planos tem fidelidade?',
    answer: 'Não, nossos planos não tem fidelidade mas nos contate antes de fazer qualquer escolha. Iremos te oferecer as melhores opções, beleza?'
  },
  {
    subject: 'Nossos Planos',
    text: 'Os planos tem reajuste?',
    answer: 'Sim. O ajuste é anual de acordo com IGPM – FGV mas  avisaremos sobre qualquer mudança.'
  },
  {
    subject: 'Nossos Planos',
    text: 'Quem pode contratar o plano?',
    answer: 'Qualquer pessoa, mas lembrando que é necessário ser maior de idade (acima de 18 anos).'
  },
  {
    subject: 'Nossos Planos',
    text: 'Preciso enviar documentos para contratar?',
    answer: 'Não, aqui com W.Dental é tudo digital. Não solicitamos envio de documentos, somente algumas informações no ato da contratação.'
  },
  {
    subject: 'Nossos Planos',
    text: 'Posso incluir dependentes no meu plano?',
    answer: 'Sim, você pode incluir seus dependentes no momento da contratação, será solicitado o grau de parentesco e CPF do dependente.'
  },
  {
    subject: 'Nossos Planos',
    text: 'Os planos cobrem todos os tipos de prótese?',
    answer: 'Não. Os planos cobrem algumas modalidades de próteses de acordo com a cobertura do Rol Mínimo da ANS – Agência Nacional de Saúde.'
  },
  {
    subject: 'Nossos Planos',
    text: 'Se precisar de atendimento de urgência, como faço?',
    answer: 'Você pode consultar no site ou aplicativo a especialidade urgência na localidade que precisa de atendimento. Se precisar de ajuda, fale com a gente.'
  },
  {
    subject: 'Rede Credenciada',
    text: 'Meu dentista alega que não aceita W.Dental, o que faço?',
    answer: 'Não se preocupe! Informe que fazemos parte da Rede Brazil Dental e se mesmo assim ele informar que não é conveniado, entre em contato com a gente e daremos outras opções. '
  },
  {
    subject: 'Rede Credenciada',
    text: 'Vou receber um manual com os profissionais credenciados?',
    answer: 'Não, mas você pode consultar quantas vezes quiser em “Rede credenciada” em nosso site ou pelo seu aplicativo.'
  },
  {
    subject: 'Rede Credenciada',
    text: 'Posso usar meu plano em qualquer lugar do Brasil?',
    answer: 'Sim, a cobertura de nossos planos é nacional e disponibilizamos mais de 17 mil opções de atendimento para melhor te atender. '
  },
  {
    subject: 'Rede Credenciada',
    text: 'Preciso solicitar autorização para atendimento?',
    answer: 'Não, pesquise o dentista que faz parte da rede W.Dental para sua primeira consulta, ele informará as orientações e vai ficar responsável pela solicitações de procedimentos que você vai precisar. '
  }
]